import events from '../shared/events';

export function supplementOrderControlInteraction(label) {
    events._orderControlInteractionLabel('Supplement Order Control', label);
}

export function autoShipEvent(isAutoShip){
    events._gaEvent('Supplement Order Control', 'ATS/OTS Change', isAutoShip ? 'Autoship' : 'One-time');
}

export function doseTypeChangeEvent(id){
    const types = {
        '-1': 'NONE', 
        '1997690860': 'CUSTOM', 
        '1997690859': 'LOADING', 
        '1997690858': 'MAINTENANCE'
    };
    events._gaEvent('Supplement Order Control', 'Dose Type Change', types[id.toString()]);
}

export function packagingTypeChange(type){
    events._gaEvent('Supplement Order Control', 'Package Type Change', type);    
}

export function badgeClickEvent(name){
    events._gaEvent('Supplement Product Class Page', 'Badge Click', name);    
}

export function overviewLinkClickEvent(link){
    events._gaEvent('Supplement Product Class Page', 'Overview section', link);    
}

export function ingredientLinkClickEvent(link){
    events._gaEvent('Supplement Product Class Page', 'Supplement Facts Section', link);    
}

export function researchLinkClickEvent(link){
    events._gaEvent('Supplement Product Class Page', 'Research Section', link);    
}

export function videoPlayEvent(title){
    events._gaEvent('Supplement Product Class Page', 'Video Section', title);    
}

